import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Add, Remove } from '@material-ui/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterMembershipTypesForHousehold } from '../../../utils/membershipTypes'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	grid: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		width: '60%'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				width: '100%',
				maxHeight: '70px'
			}
		}
	},
	incrementBtn: {
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 6,
		border: '1px solid #D0CFD2',
		height: 56,
		width: 56
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	},
	col1: {
		width: '55%'
	},
	col2: {
		width: '20%'
	},
	col3: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end'
	}
}))

const AddDogsDialog = ({ isShown, setIsShown, addAdditionalDogs, membership, client }) => {
	const classes = useStyles()
	const membershipTypes = useSelector((state) => state.specific.households.membershipTypes)
	const membershipTypesByFacility =
		filterMembershipTypesForHousehold(membershipTypes, client).filter((m) => m.status === 'active') || []

	const facility = useSelector((state) => state.specific.facilities.selected)

	const [entry, setEntry] = useState({
		charge_type: '',
		number: ''
	})

	const [appliedPromo, setAppliedPromo] = useState(null)
	const [hasPromo, addPromo] = useState(false)
	const [promo, setPromo] = useState('')
	const [promoLoading, setPromoLoading] = useState(false)
	const [discountApplied, applyDiscount] = useState(false)
	const [discount, setDiscount] = useState(0)
	const [accountCharged, setAccountCharged] = useState(false)

	useEffect(() => {
		if (membership && membership._id) {
			setEntry({
				...membership,
				number: 1,
				charge_type: '',
				transaction_id: '',
				access_type: 'membership'
			})
		}
	}, [membership])

	const formatAndAddDogs = (entry) => {
		let membership = {
			facility_id: facility._id,
			additional_dogs: entry.number,
			charge_type: entry.charge_type,
			transaction_id: entry.transaction_id,
			discount: discount && discountApplied ? discount : 0
		}
		addAdditionalDogs(membership, entry._id)
	}

	const isValidMembership = (membership) => {
		if (membership?.grandfathered_pricing) {
			return true
		}
		if (!membership.number || !membership.charge_type || membership.number + membership.number_of_pets > 4) {
			return false
		}
		return true
	}

	const getAdditionalPetPrice = () => {
		if (!entry.type) return '-'
		let price = 0
		if (entry.type === 'day_pass') {
			let day = moment().format('dddd')
			let additional_pet_price = facility.daypass_prices[day].additional_pet_price
			price = additional_pet_price
		} else {

			if (entry?.grandfathered_pricing) {
				price = 0
			} else {
				let membership = membershipTypesByFacility.find((m) => m.type === entry.type)
				price = membership ? membership?.additional_pet_fee : 0
			}


		}

		return price / 100
	}

	const getTotal = () => {
		if (!entry.type) return '-'
		let membershipType = null
		let add_price = 0
		if (entry.access_type === 'day_pass') {
			let day = moment().format('dddd')
			let additional_pet_price = facility.daypass_prices[day].additional_pet_price
			add_price = additional_pet_price
		}
		if (entry.access_type === 'membership') {
			membershipType = membershipTypesByFacility.find((m) => m.type === entry.type)
			if (entry?.grandfathered_pricing) {
				add_price = 0
			} else {
				add_price = membershipType?.additional_pet_fee
			}
		}
		let newNum = entry.number
		let add = add_price * newNum
		let total = add

		if (membershipType && entry.start_date && entry.end_date) {
			// this prorate logic matches what is in the client app and api
			let proRatePercent = 0
			let proRateDiscount = 0
			const now = moment().startOf('day')
			if (membershipType.billing_method === 'monthly') {
				const diffFromStart = Math.abs(now.diff(moment(entry.start_date).startOf('day'), 'days'))
				proRatePercent = diffFromStart / 30
			}
			if (membershipType.billing_method === 'annual') {
				// days since start of the membership year term / 365
				proRatePercent = Math.abs(now.diff(moment(entry.start_date).startOf('day'), 'days')) / 365
			}
			if (proRatePercent > 0 && proRatePercent <= 1) {
				proRateDiscount = total * proRatePercent
			}
			total = total - proRateDiscount
		}

		if (discount && discountApplied) {
			let disc = discount / 100
			let off = total * disc
			total = total - off
		}

		return `$${(total / 100).toFixed(2)}`
	}

	const getPromoBlock = () => {
		return (
			<div
				style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-start'
				}}>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginBottom: 16
					}}>
					<TextField
						variant="filled"
						value={discount || ''}
						label="Discount %"
						onChange={(e) => {
							if (!isNaN(e.target.value) && e.target.value <= 100) setDiscount(e.target.value)
						}}
					/>
					<Button
						variant="outlined"
						disabled={!discount}
						onClick={applyDiscount}
						style={{
							fontFamily: 'Nunito',
							color: '#6B4AD6',
							borderWidth: '#6B4AD6',
							borderColor: '#6B4AD6',
							height: 40,
							paddingRight: 12,
							paddingLeft: 12
						}}>
						APPLY
					</Button>
				</div>
			</div>
		)
	}

	const getSummary = () => {
		let proRate =
			moment().startOf('day').diff(moment(entry.end_date), 'days') /
			moment(entry.start_date).diff(moment(entry.end_date), 'days')

		return (
			<div
				style={{
					width: '285px',
					backgroundColor: '#F9F9F9',
					borderRadius: 6,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-start',
					alignItems: 'flex-start',
					padding: 16
				}}>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						border: `0px 0px 1px 0px solid #F3F3F3`,
						paddingBottom: 16,
						marginBottom: 16
					}}>
					<Typography
						variant="body2"
						style={{
							fontWeight: '800',
							fontSize: 16,
							color: '#1A1A35'
						}}>
						Summary
					</Typography>
				</div>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						paddingBottom: 8
					}}>
					<div className={classes.col1}>
						<Typography
							variant="body2"
							style={{
								fontWeight: '800',
								fontSize: 12,
								letterSpacing: 0.75,
								opacity: 0.75,
								color: '#1A1A35'
							}}>
							ITEM
						</Typography>
					</div>
					<div className={classes.col2}>
						<Typography
							variant="body2"
							style={{
								fontWeight: '800',
								fontSize: 12,
								letterSpacing: 0.75,
								opacity: 0.75,
								color: '#1A1A35'
							}}>
							QTY
						</Typography>
					</div>
					<div className={classes.col3}>
						<Typography
							variant="body2"
							style={{
								fontWeight: '800',
								fontSize: 12,
								letterSpacing: 0.75,
								opacity: 0.75,
								color: '#1A1A35'
							}}>
							COST
						</Typography>
					</div>
				</div>

				{entry.number ? (
					<div
						style={{
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start'
						}}>
						<div className={classes.col1}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								Additional Pets
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								{entry.number}x
							</Typography>
						</div>
						<div className={classes.col3}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								{`$${getAdditionalPetPrice()}`}
							</Typography>
						</div>
					</div>
				) : null}
				{proRate !== 1 ? (
					<div
						style={{
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start'
						}}>
						<div className={classes.col1}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									fontStyle: 'italic',
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								Pro-rated
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}></Typography>
						</div>
						<div className={classes.col3}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								{(proRate ? -(getAdditionalPetPrice() * entry.number) * (1 - proRate) : 0)
									.toFixed(2)
									.replace('-', '-$')}
							</Typography>
						</div>
					</div>
				) : null}
				{!discountApplied ? null : (
					<div
						style={{
							paddingTop: 8,
							paddingBottom: 8,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="body2"
							style={{
								fontSize: 14,
								color: '#1A1A35',
								fontStyle: 'italic',
								lineHeight: '24px'
							}}>
							Applied Discount:
						</Typography>
						<Typography
							variant="body2"
							style={{
								fontSize: 14,
								color: '#1A1A35',
								fontStyle: 'italic',
								lineHeight: '24px'
							}}>
							- {discount}%
						</Typography>
						<Button
							variant="text"
							onClick={() => applyDiscount(false)}
							style={{ paddingLeft: 0, paddingTop: 0 }}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									textDecoration: 'underline',
									lineHeight: '24px'
								}}>
								Remove
							</Typography>
						</Button>
					</div>
				)}
				<div
					style={{
						width: '100%',
						paddingTop: 8,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'flex-start'
					}}>
					<Typography
						variant="body2"
						style={{
							fontSize: 16,
							fontWeight: '600',
							color: '#1A1A35',
							lineHeight: '22px'
						}}>
						Total
					</Typography>
					<Typography
						variant="body2"
						style={{
							fontSize: 16,
							fontWeight: '600',
							color: '#1A1A35',
							lineHeight: '22px'
						}}>
						{getTotal()}
					</Typography>
				</div>
			</div>
		)
	}

	const onExit = () => {
		setIsShown(false)
		setEntry({
			charge_type: '',
			number: '1',
			transaction_id: ''
		})
		setPromo(null)
		addPromo(false)
		setAppliedPromo(false)
		setDiscount(null)
		applyDiscount(false)
		setAccountCharged(false)
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onExit={() => onExit()}
			onClose={() => onExit()}
			PaperProps={{
				style: {
					width: 920,
					maxWidth: 920,
					minHeight: 374,
					maxHeight: 500,
					overflowY: 'scroll'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				ADD ADDITIONAL DOGS
			</DialogTitle>
			<DialogContent>
				<div
					style={{
						width: '100%'
					}}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<div className={classes.grid}>
							<TextField
								variant="filled"
								value={entry.charge_type || ''}
								label="Payment Type"
								select
								style={{ width: '100%', marginBottom: 16 }}
								onChange={(e) => {
									setEntry({ ...entry, charge_type: e.target.value })
								}}>
								{['Charge Account', 'Point of Sale'].map((option) => (
									<MenuItem key={option} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>

							<div
								style={{
									width: '100%',
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									alignItems: 'center',
									marginBottom: 16
								}}>
								<TextField
									variant="filled"
									value={entry.number || ''}
									style={{ minWidth: '389px' }}
									InputProps={{
										style: {
											width: '50%',
											minWidth: 389
										}
									}}
									label="Additional Dogs"
								/>
								<div
									style={{
										display: 'flex',
										alignItems: 'center'
									}}>
									<IconButton
										className={classes.incrementBtn}
										style={{
											marginRight: '7px',
											marginLeft: '7px',
											backgroundColor: entry.number <= 1 ? '#F9F9F9' : ''
										}}
										disabled={entry.number <= 1}
										onClick={() => setEntry({ ...entry, number: entry.number - 1 })}>
										<Remove
											style={{
												size: 16,
												fill: entry.number <= 1 ? '#A2A1A4' : '#4D4C4F'
											}}
										/>
									</IconButton>
									<IconButton
										className={classes.incrementBtn}
										disabled={entry.number_of_pets + entry.number >= 4}
										onClick={() => setEntry({ ...entry, number: entry.number + 1 })}
										style={
											entry.number_of_pets + entry.number >= 4
												? { backgroundColor: '#F9F9F9' }
												: {}
										}>
										<Add
											style={{
												size: 16,
												fill:
													entry.number_of_pets + entry.number >= 4
														? '#A2A1A4'
														: '#4D4C4F'
											}}
										/>
									</IconButton>
								</div>
							</div>

							{entry.charge_type === 'Point of Sale' ? (
								<TextField
									variant="filled"
									value={entry.transaction_id || ''}
									style={{ marginBottom: 16, minWidth: 240, width: '100%' }}
									InputProps={{
										style: {
											width: '100%',
											minWidth: 240
										}
									}}
									label="Transaction ID"
									onChange={(e) => setEntry({ ...entry, transaction_id: e.target.value })}
								/>
							) : null}
							{!hasPromo ? (
								<Button
									variant="text"
									onClick={() => addPromo(true)}
									style={{ color: '#6B4AD6', paddingLeft: 0 }}>
									ADD DISCOUNT
								</Button>
							) : (
								getPromoBlock()
							)}
						</div>
						<div className={classes.receipt}>{getSummary()}</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						formatAndAddDogs(entry)
						setIsShown(false)
					}}
					color="secondary"
					disabled={!isValidMembership(entry)}>
					Confirm
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AddDogsDialog
